import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { LaunchPage, MessageTooltip, Spacer } from "@qivia/ui";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  loadCompanyPortalUrlAsync,
  selectCompanyPortalUrl,
  selectCompanyPortalUrlStatus,
} from "../billingsSlice";
import { selectCompany } from "../../homeSlice";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { EmailsFrame } from "../archives/statementsTab";

export const BillingCompanyPortal = () => {
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const companyPortalUrl = useAppSelector(selectCompanyPortalUrl);
  const companyPortalUrlStatus = useAppSelector(selectCompanyPortalUrlStatus);

  useEffect(() => {
    if (company && companyPortalUrlStatus === "idle") {
      void dispatch(loadCompanyPortalUrlAsync(company?.uuid));
    }
  }, [company, companyPortalUrlStatus, dispatch]);

  if (params.tab !== "invoices_portal") {
    return;
  }

  if (!companyPortalUrl || !company) {
    return;
  }

  if (companyPortalUrlStatus === "processing") {
    return <LaunchPage />;
  }

  const portalUrl = new URL(companyPortalUrl);
  portalUrl.searchParams.set("hideSidebar", "true");
  const portalUrlStringify = portalUrl.toString();

  return (
    <StyledCustomPortalSection>
      <MessageTooltip
        title={t("billings.portal.messageTooltip.title")}
        text={t(`billings.portal.messageTooltip.text`)}
        type="INFORMATIVE"
      />
      <Spacer y={1} />
      <EmailsFrame company={company} />
      <Spacer y={2} />
      <StyledPortalIframeContainer>
        <iframe title={t("billings.portal.link")} src={portalUrlStringify} />
      </StyledPortalIframeContainer>
    </StyledCustomPortalSection>
  );
};

const StyledPortalIframeContainer = styled.div`
  iframe {
    border-radius: 0.5rem;
    border: none; 
    width: 100%;
    height: 45rem;
  },
`;

const StyledCustomPortalSection = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  height: 100%;
`;
